<template>
        <div class="layout">
            <app-header></app-header>
        </div>
</template>
<style>
</style>
<script>
    import Vue from 'vue'
    import config from '../config.js'
    export default {
        data(){
            return{

            }
        },
        created(){
            
        },
        mounted(){

        },
        watch:{

        },
        computed: {
            
        },
        methods: {
            
        }
    }
</script>


// WEBPACK FOOTER //
// Layout.vue?dc1494ec